<template>
    <wrapper-mobile-bottom-features-wrapper thirdLevelMenu>
        <div class="buttons-cards-wrapper">
            <button-card
            v-for="menuEntry in subEntriesMenu"
            :key="`entries-menu-${menuEntry.id}-${menuEntry.iconName}`"
            :icon="menuEntry.iconName"
            :label="menuEntry.name"
            :description="menuEntry.description"
            @clicked="handleClick(menuEntry)"/>
        </div>
    </wrapper-mobile-bottom-features-wrapper>
</template>

<script setup>
import WrapperMobileBottomFeaturesWrapper from '@/components/wrappers/featuresTemplates/MobileBottomFeaturesWrapper'
import ButtonCard from '@/components/generic/buttons/Card'
/* Vue & Helpers */
import { navigateByPath, navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'
import { computed } from 'vue'
import { menuIconThirdLevelMapper } from '@/assets/scripts/mappers/menu'

/** props received
@menuData { Object } - menu data with subitems to show
*/
const props = defineProps({
    menuData: Object
})

const subEntriesMenu = computed(() => {
	return props.menuData.subitems.map(entry => {
        return {
            ...entry,
            iconName: menuIconThirdLevelMapper(entry.label)
        }
    })
})

const handleClick = item => {
    if (item.additionalData && item.additionalData.type && item.additionalData.type === 'PAYMENT_OPERATOR') {
		navigateByName({ name: routeList.PAYMENTS_SERVICES_NAME, params: { searchedPaymentData: item.additionalData.paymentOperator } })
	} else {
		if (item.firstTabLink) navigateByPath(item.firstTabLink)
		else navigateByPath(item.link)
	}
}
</script>

<style lang="scss" scoped>
.mobile-bottom-entries-features-wrapper {

    :deep(.mobile-bottom-entries-feature-content-container) {
        padding: 16px;

        .buttons-cards-wrapper {
            height: auto;

            display: flex;

            flex-direction: row;
            flex-wrap: wrap;
            align-content: flex-start;
            gap: 8px;

            .button-card {
                width: 100%;
            }
        }
    }
}
</style>
